import { Languages } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const LegalTranslationNote = () => {
  const { lang } = useLanguage();
  if (lang === "en") return null;
  return (
    <div
      className="mt-6 flex items-start gap-3 rounded-2xl border border-teal/30 bg-teal-light/60 p-4 text-sm text-navy"
      data-testid="legal-translation-note"
    >
      <Languages className="w-5 h-5 text-teal shrink-0 mt-0.5" />
      <p>
        This translation is provided for your convenience. The English version of this document is the official
        version and governs in case of any difference.
      </p>
    </div>
  );
};
